/* eslint-disable arrow-parens */
import "@babel/polyfill";
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import axios from "axios";
import VueAxios from "vue-axios";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import VueTelInput from "vue-tel-input";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";

Vue.config.productionTip = false;

const isProd = process.env.NODE_ENV === "production";

Vue.use(VueAxios, axios);
Vue.use(VueAnalytics, {
  id: "UA-68575253-3",
  router,
  autoTracking: {
    exception: true,
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
});
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_PLACE_APIKEY,
});
Vue.use(VueTelInput);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount("#app");
